import { ComponentProps } from "react"

export function PdfIcon(props: ComponentProps<"img">) {
	return <img
		title={`Скачать PDF файл`}
		style={{ width: "3rem" }}
		src="https://public.kemsu.ru/icons/pdf.png"
		{...props}
	/>
}

